import {
  DISABLED_V2_COMPONENTS,
  ENABLE_TEST_UTILITIES,
  ENABLE_V2_COMPONENTS,
} from '../constants/ActionTypes'

/**
 * @typedef {ReturnType<typeof enableTestUtilities> | ReturnType<typeof enableV2> | ReturnType<typeof disableV2>} TestingAndDiagnosisActions
 */

/**
 * @return {{ type: 'ENABLE_TEST_UTILITIES' }}
 */
export const enableTestUtilities = () => ({
  type: ENABLE_TEST_UTILITIES,
})

/**
 * @return {{ type: 'ENABLE_V2_COMPONENTS' }}
 */
export const enableV2 = () => ({
  type: ENABLE_V2_COMPONENTS,
})

/**
 * @return {{ type: 'DISABLED_V2_COMPONENTS' }}
 */
export const disableV2 = () => ({
  type: DISABLED_V2_COMPONENTS,
})
